import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=663c5864&"
import script from "./StudentsTable.vue?vue&type=script&lang=js&"
export * from "./StudentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports